import React from 'react'
import { Button } from '@driftt/tide-core'
import cx from 'classnames'
import { withRouter } from 'react-router-dom'
import './style.css'

const StartBuildingButton = ({ size, className, history }) => (
  <div className={cx(
    'start-building-button',
    `start-building-button-${size}`,
    className)}>

    <Button
      onClick={() => history.push('/apps')}
      size={size}>
      Start Building with Drift
    </Button>
  </div>
)

export default withRouter(StartBuildingButton)
